import { useSelector } from 'react-redux';
import { InlineLink, SectionAlert, Txt } from '@vst/beam';
import { Router } from '@vst/beam-icons/icons';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { DateFormat } from '@app/constants';
import { selectingPendingInstallation } from '@app/redux/pendingInstallation';
import { formatTimeInterval } from '@app/redux/scheduleInstallation';

import styles from './Alert.module.scss';

type ScheduledAlertProps = {
  handleRedirect: () => void;
};

export const ScheduledAlert = ({ handleRedirect }: ScheduledAlertProps) => {
  const { t } = useTranslation('Profile');

  const { newOfferName, schedule } = useSelector(selectingPendingInstallation);
  const date = format(new Date(schedule?.from), DateFormat.SHORT_MONTH_DAY);
  const interval = formatTimeInterval([schedule?.from, schedule?.to]);

  return (
    <SectionAlert variant="infoPrimary" icon={Router}>
      <div className={styles['alert-content']}>
        <Txt data-cy="text" component="span" variant="smallRegular" color="regular">
          {t('scheduledAlert.placedOrder', { newOfferName })}
        </Txt>
        <Txt data-cy="highlight" component="span" variant="smallBold" color="regular">
          {t('scheduledAlert.installationDate', {
            date,
            interval,
          })}
        </Txt>
        .
        <InlineLink
          data-cy="cta"
          variant="primary"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleRedirect();
          }}
        >
          {t('scheduledAlert.cta')}
        </InlineLink>
      </div>
    </SectionAlert>
  );
};
